<template>
  <v-select
    :value="value"
    :items="roles"
    item-text="name"
    :rules="$options.rules.roles"
    :disabled="disabled"
    :label="$t('user.roles')"
    prepend-icon="mdi-book-lock-open"
    multiple
    @input="$emit('input', $event)"
  >
    <template v-if="!disabled" #append-outer>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        <div>
          <template v-for="role in roles">
            <div
              :key="`name-${role.value}`"
              class="font-italic font-weight-bold"
              v-text="`${role.name} :`"
            />
            <div
              :key="`detail-${role.value}`"
              class="ml-3"
              v-text="role.detail"
            />
          </template>
        </div>
      </v-tooltip>
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
import FormRules from 'src/utils/form-rules'

export default {
  name: 'RolesField',
  props: {
    value: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('me', {
      userRoleList: 'roles',
    }),
    hasOwnerRole () {
      return this.userRoleList.includes('OWNER')
    },
    roles () {
      const roles = [
        { value: 'ADMIN', ...this.$t('user.roleList.ADMIN') },
        { value: 'PARAMS', ...this.$t('user.roleList.PARAMS') },
        { value: 'COACH', ...this.$t('user.roleList.COACH') },
      ]

      if (this.value.includes('OWNER') || this.hasOwnerRole) {
        roles.push({
          value: 'OWNER',
          ...this.$t('user.roleList.OWNER'),
          disabled: !this.hasOwnerRole,
        })
      }

      return roles
    },
  },
  rules: {
    roles: [
      FormRules.required('error.form.required'),
    ],
  },
}
</script>
